module.exports = __webpack_public_path__ + "static/media/cutsAndRejections.03ebe9f1.svg";